const bar = document.querySelector('.announcement-bar-section .utility-bar');
const navbar = document.querySelector('.section-header .header-wrapper');

let lastScrollY = 0;

window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY
    if(lastScrollY > 0){
        if(currentScrollY > lastScrollY){
            if(lastScrollY > 0){
                bar.classList.add('scrolling');
                navbar.classList.add('scrolling');
            }
        } else {
            bar.classList.remove('scrolling');
            navbar.classList.remove('scrolling');
        }
    }
    lastScrollY = currentScrollY;
})
